import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';

import router from '@/router';
import { CampaignsCollection } from './collections';

const SIZE = 20;

export const getCampaigns = async ({ rootState, state, getters, dispatch, commit }, { page: page = 1, redirect: redirect = true }) => {
  let queryParams = [],
    query = {};

  queryParams.push(`page=${page - 1}`);
  queryParams.push(`limit=${SIZE}`);

  if (rootState.search) {
    queryParams.push(`filters[]=term:${rootState.search}`);
    query.search = rootState.search;
  }

  let url = `${hateoas.url('search_whitelabel_campaigns', { domain: getters.domain })}?${queryParams.join('&')}`;

  let response = await dispatch('get', url);

  commit('updateState', { object: state.campaigns, property: 'collection', value: new CampaignsCollection(response.data._embedded.items, getters.domain).campaigns });

  commit('updateState', { object: state, property: 'maxPages', value: Math.ceil(response.data.total_results / SIZE) });

  if (redirect) {
    router.push({ name: 'products', params: { page: `${page}` }, query });
  }

  dispatch('viewPage');

  storage.set('last-listing-url', { url: rootState.route.fullPath, time: new Date() });

  return response;
};